import { IAbsenceTypeDTO, IAbsenceTypesRequestDTO } from 'src/api/dtos';
import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';
import { IListQueryResult } from 'src/api/types';
import { getAxiosParams } from 'src/shared/utils';

export default class AbsenceTypeRepository extends CommonRepository {
  private static readonly baseRoute = '/absenceTypes';
  private static readonly apiURL = AbsenceTypeRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (params: IAbsenceTypesRequestDTO): Promise<IAbsenceTypeDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IAbsenceTypeDTO>>(
        AbsenceTypeRepository.apiURL,
        getAxiosParams(params),
      );
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
